module.exports = __webpack_public_path__ + "img/19e16b1db52349c8a9fb343f1993c83c.9aa599d7.jpg";